import React from 'react';
import { motion } from 'framer-motion';
import { PricingBlock } from '../ui/PricingBlock';
import { CTAButton } from '../ui/CTAButton';
export const Hero = () => {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-108">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-glow opacity-50 pointer-events-none" data-id="element-109" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="mb-8 md:mb-12" data-id="element-111">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-amber-400 mb-6 tracking-wider leading-tight drop-shadow-lg" data-id="element-112">
            DMT: LA MOLÉCULA
            <br data-id="element-113" />
            DE DIOS
          </h1>
          <p className="text-xl md:text-2xl font-serif italic text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-114">
            El libro que no te pide que creas nada.
            <br data-id="element-115" />
            <span className="text-amber-200" data-id="element-116">Solo que recuerdes.</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full max-w-md mx-auto mb-12 perspective-1000" data-id="element-117">
          {/* Subtle floating animation for the book */}
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 shadow-2xl shadow-amber-500/20 rounded-xl overflow-hidden border border-white/10" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/rT81seYCUHiK6wFwJax7qT/Imagen.png" alt="DMT: La Molécula de Dios Book Cover" className="w-full h-auto object-cover" data-id="element-119" />
          </motion.div>
          {/* Backlight for the book */}
          <div className="absolute inset-0 bg-amber-500/20 blur-[100px] -z-10 rounded-full" data-id="element-120" />
        </motion.div>

        <PricingBlock data-id="element-121" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="mt-4" data-id="element-122">
          <CTAButton data-id="element-123">
            Comenzar el Viaje <span className="ml-2" data-id="element-124">→</span>
          </CTAButton>
        </motion.div>
      </div>
    </section>;
};